import { render, staticRenderFns } from "./TeamsHandle.vue?vue&type=template&id=34535fca&scoped=true"
import script from "./TeamsHandle.vue?vue&type=script&lang=js"
export * from "./TeamsHandle.vue?vue&type=script&lang=js"
import style0 from "./TeamsHandle.vue?vue&type=style&index=0&id=34535fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34535fca",
  null
  
)

export default component.exports